module.exports = __webpack_public_path__ + "media/images/konintodoke/diagnosis/chiisana_sekai_bannin-e558df0f8f2e7d2b42ffd331d66defa2.png";